import { FC, ReactNode, useState } from 'react'
import { useWidgetContext } from '@dxp-module/common'
import CashContext from '../context/CashContext'
import { isCurrentInputCash } from '../utils/isCurrentInputCash'

const CashContextProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const { configuration } = useWidgetContext()
  const [isCash, setIsCash] = useState(
    isCurrentInputCash(configuration.dimensions)
  )

  const value = {
    isCash: isCash,
    setIsCash: setIsCash,
  }

  return <CashContext.Provider value={value}>{children} </CashContext.Provider>
}

export default CashContextProvider
